import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Text, Box } from '@qga/roo-ui/components';

const RoomTitle = ({ name, maxOccupantCount }) => (
  <Box mb={5} pb={5} borderBottom={1} borderColor="greys.alto">
    <Text fontSize="lg" color="greys.charcoal">
      {name}
    </Text>
    <Box mt={2}>
      <Icon name="people" size={20} mr={3} color="greys.steel" />
      <Text fontSize="base" color="greys.steel" data-testid="room-max-occupants">
        Sleeps {maxOccupantCount}
      </Text>
    </Box>
  </Box>
);

RoomTitle.propTypes = {
  name: PropTypes.string.isRequired,
  maxOccupantCount: PropTypes.number.isRequired,
};

export default RoomTitle;
